export default __webpack_public_path__ + "b73998f2b804dc92daf7d9538bb9f926.png";